import { name } from "./block.json";

const mapStyle = [
	{
		elementType: "geometry",
		stylers: [
			{
				color: "#242f3e",
			},
		],
	},
	{
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#746855",
			},
		],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [
			{
				color: "#242f3e",
			},
		],
	},
	{
		featureType: "administrative.locality",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#d59563",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#d59563",
			},
		],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [
			{
				color: "#263c3f",
			},
		],
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#6b9a76",
			},
		],
	},
	{
		featureType: "road",
		elementType: "geometry",
		stylers: [
			{
				color: "#38414e",
			},
		],
	},
	{
		featureType: "road",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#212a37",
			},
		],
	},
	{
		featureType: "road",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#9ca5b3",
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [
			{
				color: "#746855",
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#1f2835",
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#f3d19c",
			},
		],
	},
	{
		featureType: "transit",
		elementType: "geometry",
		stylers: [
			{
				color: "#2f3948",
			},
		],
	},
	{
		featureType: "transit.station",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#d59563",
			},
		],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [
			{
				color: "#17263c",
			},
		],
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#515c6d",
			},
		],
	},
	{
		featureType: "water",
		elementType: "labels.text.stroke",
		stylers: [
			{
				color: "#17263c",
			},
		],
	},
];

function renderGoogleMap(mapContainer) {
	const lat = mapContainer.dataset.lat;
	const lng = mapContainer.dataset.lng;
	const zoom = mapContainer.dataset.zoom;
	const address = mapContainer.dataset.address;
	const offset_lat = 0;
	const offset_lng = 20;

	if (mapContainer !== null && null !== lat && null !== lng && null !== zoom) {
		let offsetApplied = false;
		let latOffset = 0;
		let lngOffset = 0;
		let latLngCenter = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

		let mapOptions = {
			zoom: parseInt(`${zoom}`), // initialize zoom level - the max value is 21
			streetViewControl: false, // hide the yellow Street View pegman
			scaleControl: true, // allow users to zoom the Google Map
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latLngCenter,
			disableDefaultUI: true,
			// draggable: true,
			keyboardShortcuts: false,
			// gestureHandling: "none",
			styles: mapStyle,
			zoomControl: true,
			mapTypeControl: false,
			rotateControl: false,
			fullscreenControl: false,
		};

		let map = new google.maps.Map(mapContainer, mapOptions);

		google.maps.event.addListener(map, "bounds_changed", function () {
			if (offsetApplied === false) {
				const dimensions = googleMapCalculateDimensions(map);
				latOffset = 0; //dimensions.height / 100 * parseFloat(offset_lat);
				lngOffset = 0; //dimensions.width / 100 * parseFloat(offset_lng);
				latLngCenter = new google.maps.LatLng(
					parseFloat(lat) + latOffset,
					parseFloat(lng) + lngOffset,
				);
				map.setCenter(latLngCenter);
				offsetApplied = true;
			}
		});

		// Show the default red marker at the location
		let marker = new google.maps.Marker({
			position: latLngCenter,
			map: map,
			draggable: false,
			title: address,
		});
	}
}

function googleMapCalculateDimensions(map) {
	const bounds = map.getBounds();
	const ne = bounds.getNorthEast();
	const sw = bounds.getSouthWest();
	const height = ne.lat() - sw.lat();
	const width = ne.lng() - sw.lng();
	return { height, width };
}

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block) {
	const init = () => {
		const mapContainers = block.querySelectorAll(
			".wp-block-site-map__map-canvas",
		);

		mapContainers.forEach(function (mapContainer) {
			renderGoogleMap(mapContainer);
		});
	};

	if (window?.google && window?.google?.maps) {
		init();
	} else {
		window.addEventListener("GoogleMapsLoaded", init);
	}
}
